module.exports = __webpack_public_path__ + "static/media/energystorage.596df345.png";